import React from 'react';
import { Container, IconContainer, IconImage, Title, Value, Description } from './styles';

export default function MetricCard({ icon, title, value, description }) {
  const isImage = typeof icon === 'string';
  const IconComponent = !isImage ? icon : null;
  return (
    <Container>
      <IconContainer>
        {icon && isImage && <IconImage src={icon} alt={title} />}
        {IconComponent && <IconComponent style={{ fontSize: 28, color: '#000fff' }} />}
      </IconContainer>
      <Title>{title}</Title>
      <Value>{value}</Value>
      <Description dangerouslySetInnerHTML={{ __html: description }} />
    </Container>
  );
}
